const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export const money = (n) => usd.format(Number(n) || 0);

export function fmtDate(iso, opts = { month: "short", day: "numeric", year: "numeric" }) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", opts);
}

export function monthLabel(ym) {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

export function shiftMonth(ym, delta) {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export const todayIn = (tz) => new Intl.DateTimeFormat("en-CA", { timeZone: tz }).format(new Date());

export const browserTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";

export function initials(name = "") {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");
}

export function greeting() {
  const h = new Date().getHours();
  return h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
}

export const BILL_STATUS = {
  upcoming: { label: "Upcoming", rgb: "var(--glow-calendar)" },
  overdue: { label: "Overdue", rgb: "var(--glow-media)" },
  paid: { label: "Paid", rgb: "var(--glow-money)" },
};
